import PropTypes from 'prop-types';
import Markdown from '@mysidewalk/markdown';

import ApportionableStatus from '../availability/ApportionableStatus';
import FeatureClassAvailability from '../availability/FeatureClassAvailability';

function DimensionAttributionDetails({
  attribution,
}) {
  const options = {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  };
  const publishedDates = attribution.publishedDates.map(
    (pd) => pd.toLocaleDateString(undefined, options),
  );
  return (
    <div>
      <ul className="detail-list">
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Author Organization(s)
          </div>
          <div className="detail-list__item-detail">
            <Markdown>
              {attribution.authorOrganizations.join('  \n')}
            </Markdown>
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Data Source(s)
          </div>
          <div className="detail-list__item-detail">
            <Markdown>
              {attribution.dataTableTitles.join('  \n')}
            </Markdown>
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Source Link(s)
          </div>
          <div className="detail-list__item-detail">
            <Markdown>
              {attribution.sourceLinks.join('  \n')}
            </Markdown>
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Time
          </div>
          <div className="detail-list__item-detail">
            {attribution.timeLongNames.join(', ')}
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Date(s) Published
          </div>
          <div className="detail-list__item-detail">
            {publishedDates.map((pd) => <div key={pd}>{pd}</div>)}
          </div>
        </li>
        {attribution.sourceTables
          && (
          <li className="detail-list__item">
            <div className="detail-list__item-label">
              Table(s)
            </div>
            <div className="detail-list__item-detail">
              {attribution.sourceTables.join(', ')}
            </div>
          </li>
          )}
        {attribution.universes
          && (
          <li className="detail-list__item">
            <div className="detail-list__item-label">
              Universe(s)
            </div>
            <div className="detail-list__item-detail">
              {attribution.universes.join(', ')}
            </div>
          </li>
          )}
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Description
          </div>
          <div className="detail-list__item-detail">
            <Markdown>
              {attribution.description}
            </Markdown>
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Calculation Methodology
          </div>
          <div className="detail-list__item-detail">
            <Markdown>
              {attribution.calculationMethodology}
            </Markdown>
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Custom Geographies
          </div>
          <div className="detail-list__item-detail">
            <ApportionableStatus
              canBeApportioned={attribution.supportsCustomGeographies}
            />
          </div>
        </li>
        <li className="detail-list__item">
          <div className="detail-list__item-label">
            Availability
          </div>
          <div className="detail-list__item-detail">
            <FeatureClassAvailability
              available={attribution.featureClasses}
            />
          </div>
        </li>
      </ul>
    </div>
  );
}

DimensionAttributionDetails.propTypes = {
  attribution: PropTypes.shape({
    authorOrganizations: PropTypes.arrayOf(PropTypes.string),
    calculationMethodology: PropTypes.string,
    dataTableTitles: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.string,
    featureClasses: PropTypes.arrayOf(PropTypes.number),
    publishedDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    sourceLinks: PropTypes.arrayOf(PropTypes.string),
    sourceNames: PropTypes.arrayOf(PropTypes.string),
    sourceTables: PropTypes.arrayOf(PropTypes.string),
    supportsCustomGeographies: PropTypes.bool,
    timeLongNames: PropTypes.arrayOf(PropTypes.string),
    universes: PropTypes.arrayOf(PropTypes.string),
  }),
};

DimensionAttributionDetails.defaultProps = {
  attribution: null,
};

export default DimensionAttributionDetails;
